import React, { Component } from "react";
import { connect } from 'react-redux';
import moment from 'moment';
import classes from "./Calendar.css";
import Icon from '../UI/Icons/index';
import { bookingProcessSetDate, bookingProcessSetStep } from "../../store/actions/bookingProcess";
import { getMonthName, searchForMondayFromDate } from "../../utils";

class Week extends Component {
  render() {
    let days = [];
    const {
      date,
      month,
      selected,
      select,
      translations,
    } = this.props;

    let dayToRender = date.clone();

    for (var i = 0; i < 7; i++) {
      let day = {
        name: dayToRender.format("ddd"),
        number: dayToRender.date(),
        isCurrentMonth: dayToRender.month() === month.month(),
        isToday: dayToRender.isSame(new Date(), "day"),
        isTomorrow: dayToRender.isSame(moment().add(1, 'day'), "day"),
        date: dayToRender.clone()
      };
      days.push(
        <Day
          day={day}
          selected={selected}
          select={select}
          key={day.date}
          maxDate={this.props.maxDate}
          translations={translations}
        />
      );
      dayToRender.add(1, "day");
    }

    return (
      <div className={classes.Row} key={days[0]}>
        {days}
      </div>
    );
  }

}

class Day extends Component {
  render() {
    const {
      day,
      day: {
        date,
        isCurrentMonth,
        isToday,
        isTomorrow,
        number
      },
      select,
      selected,
      translations
    } = this.props;

    const isBefore = day.date.isBefore();
    let isDisabled = (isBefore && !isToday) || day.date.isAfter(this.props.maxDate);
    const isNotVisible = !isToday && (day.date.isBefore() || day.date.isAfter(this.props.maxDate));

    let value = null;
    let nameOfDay = null;
    if (isToday) {
      value = translations.label_today;
      nameOfDay = null;
    } else if (isTomorrow) {
      value = translations.label_tomorrow;
      nameOfDay = null;
    } else {
      value = number;
      nameOfDay = <span className={classes.DayName}>{day.name}</span>
    }

    return (
      <button
        key={date.toString()}
        className={[
          classes.Day,
          isNotVisible ? classes.IsNotVisible : '',
          isToday ? classes.Today : "",
          isTomorrow ? classes.Tomorrow : '',
          isCurrentMonth ? "" : classes.DifferentMonth,
          date.isSame(selected) ? classes.Selected : "",
          isDisabled ? classes.Disabled : ''
        ].join(' ')}
        onClick={() => select(day)}
        disabled={isDisabled}
      >
        {nameOfDay}
        <span className={classes.DayNum}>{value}</span>
      </button>
    );
  }
}

class Calendar extends Component {
  state = {
    // The current month, it doesn't change.
    currentMonth: moment(),
    // The current selected month
    month: moment(this.props.dateSelected),
    selected: moment(this.props.dateSelected).startOf('day'),
    maxDate: moment().add(this.props.maxBookingDaysInAdvance, 'day'),
  }

  componentDidMount() {
    console.log(this.props.dateSelected)
    this.props.onSelectDate(this.props.dateSelected);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.maxBookingDaysInAdvance !== this.props.maxBookingDaysInAdvance) {
      console.log('Updating desktop max booking in advance calendar');
      this.setState({ maxDate: moment().add(this.props.maxBookingDaysInAdvance, 'day') });
    }
  }

  previous = () => {
    this.setState({
      month: this.state.month.subtract(1, 'month'),
    });
  }

  next = () => {
    this.setState({
      month: this.state.month.add(1, 'month'),
    });
  }

  select(day) {
    this.props.onSelectDate(day.date.format('YYYY-MM-DD'));
    this.setState({
      selected: day.date,
      month: day.date.clone(),
    });
  }

  renderWeeks() {
    let weeks = [];
    let done = false;

    const {
      selected,
      month,
      currentMonth,
      maxDate,
    } = this.state;

    const today = moment();
    
    // If it's the current month start at the beginning of the week, otherwise start at the beginning of the month
    let dayToStartFrom = null;
    if (currentMonth.month() === month.month()) {
      dayToStartFrom = today.clone().startOf('week');
    } else {
      if (month.clone().startOf('month').weekday() === 0) {
        dayToStartFrom = month.clone().startOf('month');
      } else {
        dayToStartFrom = searchForMondayFromDate(month.clone().startOf('month').subtract(1, 'week'));
      }
    }
    
    // Clone of the first day to start from to use in the while loop
    let dateToRenderWeek = dayToStartFrom.clone();
    let monthIndex = month.clone().month();

    while (!done) {
      weeks.push(
        <Week
          key={dateToRenderWeek.clone()}
          date={dateToRenderWeek.clone()}
          month={month}
          select={(day) => this.select(day)}
          selected={selected}
          maxDate={maxDate}
          translations={this.props.translations}
        />
      );

      // Add 1 week to the loop utility date
      dateToRenderWeek.add(1, 'w');

      // We are done if the next week is not from the current rendered month or if we exceeded the max date
      done = monthIndex !== dateToRenderWeek.month() || dateToRenderWeek.isAfter(maxDate, 'day');
      monthIndex = dateToRenderWeek.month();
    }

    return weeks;
  };

  renderMonthLabel() {
    const {
      month,
    } = this.state;
    return <span className={classes.MonthLabel}>{getMonthName(month.format("MM"), this.props.translations)}</span>;
  }

  render() {
    return (
      <section className={classes.Calendar}>
        <header className={classes.Header}>
          <button
            onClick={this.previous}
            className={classes.ArrowMonth}
            // If the year is more than today we allow to go back, if it is equal we check if the month is greater than today
            disabled={!(this.state.month.year() > this.state.currentMonth.year() || this.state.month.month() > this.state.currentMonth.month())} >
            <Icon
              name="arrowleft"
              height="20"
              width="23"
              fill={!(this.state.month.year() > this.state.currentMonth.year() || this.state.month.month() > this.state.currentMonth.month()) ? '#ededed' : '#464041'} />
          </button>
          {this.renderMonthLabel()}
          <button
            onClick={this.next}
            className={classes.ArrowMonth}
            // If the year is less than max date we are allowed to move forward, if it is equal we check if the
            // month is less than the max data month
            disabled={!(this.state.month.year() < this.state.maxDate.year() || this.state.month.month() < this.state.maxDate.month())}
          >
            <Icon
              name="arrowright"
              height="20"
              width="23"
              fill={!(this.state.month.year() < this.state.maxDate.year() || this.state.month.month() < this.state.maxDate.month()) ? '#ededed' : '#464041'}
              onClick={this.previous}
            />
          </button>
        </header>
        {this.renderWeeks()}
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateSelected: state.bookingProcessReducer.dateSelected,
    translations: state.settingsReducer.translations,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSelectDate: date => dispatch(bookingProcessSetDate(date)),
    onNextStep: () => dispatch(bookingProcessSetStep(4))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);


// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.js